/**
 * FR-3.22 verdict bands, shared so the server's effective thresholds and the
 * settings form's default hints agree (HS2-GR2Q4V).
 */
export interface VerdictThresholds {
  /** Best quote within this % of the benchmark midpoint is `fair`. */
  fairPct: number;
  /** Up to this % above midpoint is `slightly-high`. */
  slightlyHighPct: number;
  /** Up to this % above is `high`; beyond it is `very-high`. */
  highPct: number;
  /** More than this % under midpoint is `below-market`. */
  belowMarketPct: number;
  /** Landed import cheaper than the best quote by at least this % → prefer import. */
  importPreferenceMarginPct: number;
}

/** Verdict bands from FR-3.22. */
export const DEFAULT_VERDICT_THRESHOLDS: VerdictThresholds = {
  fairPct: 10,
  slightlyHighPct: 25,
  highPct: 50,
  belowMarketPct: 10,
  importPreferenceMarginPct: 15,
};
